import { render, staticRenderFns } from "./LiabilityMortgageFull.vue?vue&type=template&id=427246d6"
import script from "./LiabilityMortgageFull.vue?vue&type=script&lang=js"
export * from "./LiabilityMortgageFull.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports